import React from 'react';

import { Close } from '@mui/icons-material';
import { Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import {
  gray100,
  primaryButtonBackgroundColor,
  tertiaryButtonOutlinedColor
} from '../../constants/Colors';

interface Props {
  setDialogOpen: (open: boolean) => void;
  onDelete: () => void;
  open: boolean;
  title: string;
}

const styles = {
  button: {
    boxSizing: 'border-box',
    height: '44px',
    width: 'calc(50% - 10px)'
  },
  dialog: {
    '& .MuiDialog-paper': {
      m: '16px',
      width: '560px',
      p: '24px'
    }
  },
  text: {
    color: gray100,
    fontSize: '16px',
    mt: '24px'
  },
  title: {
    color: gray100,
    fontSize: '22px',
    fontWeight: '500'
  }
};

const DeleteDialog: React.FC<Props> = (props) => {
  const { setDialogOpen, onDelete, open, title } = props;

  return (
    <Dialog open={open} sx={styles.dialog}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Typography sx={styles.title}>{title}</Typography>
        <IconButton onClick={() => setDialogOpen(false)}>
          <Close />
        </IconButton>
      </Grid>

      <Typography sx={styles.text}>
        削除すると元に戻すことはできません。よろしいですか？
      </Typography>

      <Grid container justifyContent="space-between" sx={{ mt: '40px' }}>
        <Button
          onClick={() => setDialogOpen(false)}
          sx={[tertiaryButtonOutlinedColor, styles.button]}
          variant="outlined"
        >
          キャンセル
        </Button>
        <Button
          onClick={() => onDelete()}
          sx={[primaryButtonBackgroundColor, styles.button]}
          variant="contained"
        >
          削除する
        </Button>
      </Grid>
    </Dialog>
  );
};

export default DeleteDialog;
